export enum IconPaths {
  'save-icon' = 'gfx/save-icon.png',
  'show-icon' = 'gfx/hide-icon.png',
  'bin-icon' = 'gfx/delete-icon.png',
  'hide-icon' = 'gfx/show-icon.png',
  'cancel-icon' = 'gfx/cancel-icon.png',
  'user-icon' = 'gfx/user-icon.png',
  'edit-icon' = 'gfx/edit-icon.png',
  'print-icon' = 'gfx/print.png',
  'csv-icon' = 'gfx/csv.png',
  'region-icon' = 'gfx/logo.png',
  'arrow-icon' = 'gfx/arrow_icon.png',
  'ecard-logo' = 'gfx/ecard_logo.png'
}



// WEBPACK FOOTER //
// ./src/icons.ts